import { Component, OnInit, Input } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-consent-card',
  templateUrl: './consent-card.component.html',
  styleUrls: ['./consent-card.component.scss']
})
export class ConsentCardComponent implements OnInit {
  @Input()
  consentData;
  @Input()
  index;
  accounts;
  accountCount;
  purpose;
  createdDate;
  constructor(
    private http: HttpService,
    private route: Router) { }

  ngOnInit() {
    this.setConsentData();
  }

  goToConsentConfirmation() {
    this.route.navigate(['/consent-confirm/activeConsentRecords/' + (this.consentData['eventID'])]);
  }

  setConsentData() {

    if (this.consentData) {
      // this.accounts = this.consentData.Account.accountTypes.split(/\s*,\s*/);
      // this.accountCount = this.accounts.length ? this.accounts.length - 1 : 1;
      this.createdDate = this.consentData.timeStamp;
      // this.purpose = this.consentData['Purpose'].text;
      this.purpose = this.consentData.purposeText ? this.consentData.purposeText : "Home Loan Approval";
      // if (this.consentData["Data-Items"]) {
        // if (this.consentData["Data-Items"][0].Frequency.unit == "MONTHLY") {
        // }
      // }
    }
  }
}